import TEALIUM from "../../enums/tealium-enums";
import { track } from "../../util/tealium";

/**
 * Tracks the IBO Onboarding page view on load.
 * page_category: action_report, page_detail: list_view_{YYYYMM}, page_section: IBO_onboarding
 */
export const iboOnboardingPageViewTrack = (period: string) => {
  track(
    TEALIUM.U_TAG_METHOD.VIEW,
    "",
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    TEALIUM.CATEGORY.ACTION_REPORT,
    `list_view_${period}`,
    "",
  );
};

/**
 * Tracks click on the customize KPI button (filter icon).
 * click_action: customize_KPI, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "customize_KPI",
  );
};

/**
 * Tracks cancel action in the KPI selector modal.
 * click_action: cancel_customize_KPI, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingCancelCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "cancel_customize_KPI",
  );
};

/**
 * Tracks apply action in the KPI selector modal.
 * click_action: apply_customize_KPI, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingApplyCustomizeKpiTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "apply_customize_KPI",
  );
};

/**
 * Tracks sort ascending click.
 * click_action: sort_ascending, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingSortAscendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "sort_ascending",
  );
};

/**
 * Tracks sort descending click.
 * click_action: sort_descending, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingSortDescendingTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "sort_descending",
  );
};

/**
 * Tracks ABO profile click.
 * click_action: profile, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingProfileTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "profile",
  );
};

/**
 * Tracks info button click.
 * click_action: info, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingInfoTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "info",
  );
};

/**
 * Tracks adding an ABO to the watchlist.
 * click_action: add_to_watchlist, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingAddToWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "add_to_watchlist",
  );
};

/**
 * Tracks removing an ABO from the watchlist.
 * click_action: remove_from_watchlist, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingRemoveFromWatchlistTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "remove_from_watchlist",
  );
};

/**
 * Tracks phone icon click.
 * click_action: phone_icon, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingPhoneIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "phone_icon",
  );
};

/**
 * Tracks message icon click.
 * click_action: message_icon, click_category: action_report, click_detail: IBO_onboarding
 */
export const iboOnboardingMessageIconTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.ACTION_REPORT,
    TEALIUM.CATEGORY.IBO_ONBOARDING_AR,
    "message_icon",
  );
};
